module.exports = __webpack_public_path__ + "static/media/square_and_arrow_up.9639c53c.svg";